"use client";

import { useRouter } from "next/navigation";
import { type PropsWithChildren, useCallback, useTransition } from "react";
import AllGamesNavigationContext from "./AllGamesNavigationContext";

type Props = PropsWithChildren<{
  className: string;
}>;

const AllGamesNavigationProvider: FC<Props> = ({ children, className }) => {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const navigate = useCallback(
    (href: string) =>
      startTransition(() => router.push(href, { scroll: false })),
    [router],
  );

  return (
    <AllGamesNavigationContext value={navigate}>
      <section
        aria-busy={isPending}
        data-pending={isPending ? "" : undefined}
        className={className}
      >
        {children}
      </section>
    </AllGamesNavigationContext>
  );
};

export default AllGamesNavigationProvider;
